import api from "../../index";

export const GetAllBankDetailsApi = (params) => api.get(`bankdetails/get-all-bank-details?${params}`);
export const AddUpdateBankDetailsApi = (data) => api.post('bankdetails/add-update-bank-details', data);
export const ActiveInactiveBankDetailApi = (data) => api.put('bankdetails/active-inactive-bank-detail', data);
export const DeleteBankDetailApi = (bankDetailId) => api.delete(`bankdetails/delete-bank-detail/${bankDetailId}`);